import EmailSubscribe from '@/components/EmailSubscribe/index.vue';
import ShippingDisclaimer from '@/components/ShippingDisclaimer/index.vue';
import ProductLegalText from '@/components/ProductLegalText/index.vue';
import ProductMarketingSummary from '@/components/ProductMarketingSummary/index.vue';

export default {
  name: 'ProductFootnote',
  data() {
    return {
      jsId: 'js__product__footnotes',
    };
  },
  components: {
    EmailSubscribe,
    ShippingDisclaimer,
    ProductLegalText,
    ProductMarketingSummary,
  },
  props: {
    shippingDisclaimer: {
      type: String,
      default: '',
    },
    showShippingDisclaimer: {
      type: Boolean,
      default: false,
    },
    productHeaderDetails: {
      type: String,
      default: '',
    },
    showProductHeaderDetails: {
      type: Boolean,
      default: false,
    },
    productLegalText: {
      type: String,
      default: '',
    },
    showProductLegalText: {
      type: Boolean,
      default: false,
    },
    productMarketingSummary: {
      type: String,
      default: '',
    },
    showProductMarketingSummary: {
      type: Boolean,
      default: false,
    },
  },
};
